module.exports = {"delete":"Delete","reemail":"Re-email","reprint":"Reprint","release":"Release","released":"Released","deleteTitle":"Delete ticket","deleteDescription":"Are you sure you want to delete that ticket?","releaseTitle":"Release ticket","releaseDescription":"Are you sure you want to release that ticket?"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/SearchResults/SearchResultsTicket/locales/fr.json
// module id = 1420
// module chunks = 0